import { render, staticRenderFns } from "./FormConfigUniformFormat.vue?vue&type=template&id=8939db76&"
import script from "./FormConfigUniformFormat.vue?vue&type=script&lang=js&"
export * from "./FormConfigUniformFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports